import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { applySiteTheme, getStoredTheme } from "../theme";
import { useEffect, useState } from "react";
import { getSites, getUser } from "services/apf-api.service";
import NoSites from "./Ops/NoSites";
import { useSite } from "providers/site.provider";
import { useAuth } from "providers/auth.provider";
import { Loading } from "components/Loading";

export default function WebsiteSelection() {
  const navigate = useNavigate();
  const { idToken } = useAuth();

  const [websites, setWebsites] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(false);
  const { setSelectedSite } = useSite();

  useEffect(() => {
    const fetchSites = async () => {
      setLoading(true);
      const saved = localStorage.getItem("authUser");
      if (saved) {
        const data = JSON.parse(saved);
        const user = await getUser(data.uid, idToken);
        const sites = await getSites(user.client, idToken);

        setWebsites(sites);
      }
      setLoading(false);
    };
    fetchSites();
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (websites?.length) {
    return (
      <div className="container py-10">
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-2xl font-semibold tracking-tight">
            Select a Website
          </h1>
          <button
            className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow hover:opacity-90"
            onClick={() => navigate("/websites/new")}
          >
            <Plus className="h-4 w-4" /> Add website
          </button>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {websites?.map((site: any) => (
            <button
              key={site.id}
              onClick={() => {
                const mode = getStoredTheme();
                applySiteTheme(site.id, mode === "dark");
                setSelectedSite(site);
                if (
                  site.integrations.length === 1 &&
                  site.integrations[0] === "instagram"
                ) {
                  navigate(`/social`);
                } else {
                  navigate(`/dashboard`);
                }
              }}
              className="rounded-lg border bg-card p-5 text-left shadow-sm transition hover:shadow-md"
            >
              <div className="text-lg font-medium">{site.name}</div>
              <div className="mt-1 text-sm text-muted-foreground">
                {site.domain}
              </div>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return <NoSites />;
}
